import { ValueState } from '@ui5/webcomponents-react';
import { IssueType } from 'generated/graphql';
import { CommonBaseQueryState, IssueTypeOptions } from 'stores/interfaces/CommonQueryState';
import { SetState } from 'zustand';

export const commonBaseQueryInitialStateFields = {
  selectedIssueType: IssueTypeOptions.NOT_SELECTED_ISSUE_TYPE,
  sourceText: '',
  targetLanguage: '',
  targetText: '',
  details: ''
};

export const commonBaseQueryInitialStateValueStates = {
  translationTypeValueState: ValueState.None,
  issueTypeValueState: ValueState.None,
  sourceTextValueState: ValueState.None,
  targetLanguageValueState: ValueState.None
};

// Common
export const commonBaseQueryInitialState = {
  ...commonBaseQueryInitialStateFields,
  ...commonBaseQueryInitialStateValueStates,
  languages: []
};

export const createCommonBaseQuerySlice = <T extends CommonBaseQueryState>(set: SetState<T>) => ({
  ...commonBaseQueryInitialState,
  setTranslationTypeValueState: (value: ValueState) =>
    set(() => ({ translationTypeValueState: value })),
  setIssueTypeValueState: (value: ValueState) => set(() => ({ issueTypeValueState: value })),
  setSelectedIssueType: (value: IssueType) => set(() => ({ selectedIssueType: value })),
  setSourceText: (value: string) => set(() => ({ sourceText: value })),
  setSourceTextValueState: (value: ValueState) => set(() => ({ sourceTextValueState: value })),
  setTargetLanguage: (value: string) => set(() => ({ targetLanguage: value })),
  setTargetLanguageValueState: (value: ValueState) =>
    set(() => ({ targetLanguageValueState: value })),
  setTargetText: (value: string) => set(() => ({ targetText: value })),
  setDetails: (value: string) => set(() => ({ details: value })),
  setLanguages: (value: (string | undefined)[]) => set(() => ({ languages: value }))
});
